import _taggedTemplateLiteral from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject34() {
  var data = _taggedTemplateLiteral(["\n          @media (max-width: ", "px) {\n            ", "\n          }\n        "]);

  _templateObject34 = function _templateObject34() {
    return data;
  };

  return data;
}

function _templateObject33() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  box-sizing: border-box;\n  vertical-align: top;\n  border-bottom: 1px solid var(", ");\n  ", "\n  ", "\n\n  ", "\n"]);

  _templateObject33 = function _templateObject33() {
    return data;
  };

  return data;
}

function _templateObject32() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n  padding: var(", ") 0\n    var(", ");\n  border-bottom: 0;\n\n  /* Extra padding when we have a header cell in a row */\n  th ~ & {\n    padding-top: 0;\n    padding-bottom: ", ";\n    padding-left: ", ";\n  }\n\n  &:last-of-type {\n    border-bottom: 1px solid var(", ");\n    padding-bottom: ", ";\n  }\n"]);

  _templateObject32 = function _templateObject32() {
    return data;
  };

  return data;
}

function _templateObject31() {
  var data = _taggedTemplateLiteral(["\n          @media (max-width: ", "px) {\n            ", "\n          }\n        "]);

  _templateObject31 = function _templateObject31() {
    return data;
  };

  return data;
}

function _templateObject30() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  width: ", ";\n  text-align: start;\n  border-bottom: 1px solid var(", ");\n  ", "\n  ", "\n\n  ", "\n"]);

  _templateObject30 = function _templateObject30() {
    return data;
  };

  return data;
}

function _templateObject29() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n  padding: ", ";\n  border-bottom: 0;\n"]);

  _templateObject29 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28() {
  var data = _taggedTemplateLiteral(["\n  --cell-inline-start-padding: 2px;\n  padding: ", ";\n"]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteral(["\n          @media (min-width: ", "px) {\n            ", "\n          }\n        "]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteral(["\n  /* HINT: border top for all cells that can end up at the top of the table */\n  thead > tr:first-child > &,\n  tbody:first-child > tr:first-child > &,\n  *:not(thead) + tbody > tr:first-child > & {\n    border-top: 2px solid var(", ");\n  }\n"]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["\n          @media (min-width: ", "px) {\n            display: none;\n          }\n        "]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n          display: none;\n        "]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n  padding-bottom: var(", ");\n\n  ", "\n"]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n          @media (max-width: ", "px) {\n            display: block;\n          }\n        "]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n          display: block;\n        "]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n  vertical-align: top;\n\n  ", "\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n          @media (max-width: ", "px) {\n            display: block;\n          }\n        "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n          display: block;\n        "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n          @media (max-width: ", "px) {\n            ", "\n          }\n        "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  border-top: none;\n\n  ", "\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  border-top: 2px solid var(", ");\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n          @media (max-width: ", "px) {\n            ", "\n          }\n        "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n          @media (max-width: ", "px) {\n            ", "\n          }\n        "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  padding: var(", ")\n    var(--table-border-spacing);\n  text-align: start;\n\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  padding: var(", ") 0;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n          @media (max-width: ", "px) {\n            display: block;\n          }\n        "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n          display: block;\n        "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n\n  border-collapse: separate;\n  text-align: start;\n\n  border-spacing: var(--table-border-spacing) 0;\n  table-layout: ", ";\n\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          @media (min-width: ", "px) {\n            ", "\n          }\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  /* HINT: width calculation and negative margin to override table \n  ** border spacing on the sides\n  */\n  --table-border-spacing: 8px;\n  overflow: auto;\n  ", "\n\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: calc(100% + var(--table-border-spacing) * 2);\n  margin-inline: calc(var(--table-border-spacing) * -1);\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { injectSpacing } from '../../api/spacing/injectSpacing';
var styledTableWrapperTableStyles = css(_templateObject());
export var TableWrapper = styled.div(_templateObject2(), injectSpacing('margin'), function (props) {
  switch (props.displayMode) {
    case 'list':
      {
        return;
      }

    case 'table':
      {
        return styledTableWrapperTableStyles;
      }

    default:
      {
        return css(_templateObject3(), function (_ref) {
          var theme = _ref.theme;
          return theme.breakpoints.m;
        }, styledTableWrapperTableStyles);
      }
  }
});
export var StyledTable = styled.table(_templateObject4(), function (_ref2) {
  var fixedLayout = _ref2.fixedLayout;
  return fixedLayout ? 'fixed' : 'auto';
}, function (props) {
  switch (props.displayMode) {
    case 'list':
      {
        return css(_templateObject5());
      }

    case 'table':
      {
        return;
      }

    default:
      {
        return css(_templateObject6(), function (_ref3) {
          var theme = _ref3.theme;
          return theme.breakpoints.m - 1;
        });
      }
  }
});
var tableCaptionListStyles = css(_templateObject7(), function (_ref4) {
  var theme = _ref4.theme;
  return theme.responsive.spacing.m;
});
export var TableCaption = styled.caption(_templateObject8(), function (_ref5) {
  var theme = _ref5.theme;
  return theme.responsive.spacing.m;
}, function (props) {
  switch (props.displayMode) {
    case 'list':
      {
        return tableCaptionListStyles;
      }

    case 'table':
      {
        return;
      }

    default:
      {
        return css(_templateObject9(), function (_ref6) {
          var theme = _ref6.theme;
          return theme.breakpoints.m - 1;
        }, tableCaptionListStyles);
      }
  }
});
var visuallyHidden = css(_templateObject10());
export var StyledTableHeader = styled.thead(_templateObject11(), function (props) {
  switch (props.displayMode) {
    case 'list':
      {
        return visuallyHidden;
      }

    case 'table':
      {
        return;
      }

    default:
      {
        return css(_templateObject12(), function (_ref7) {
          var theme = _ref7.theme;
          return theme.breakpoints.m - 1;
        }, visuallyHidden);
      }
  }
});
var styledTableBodyListStyles = css(_templateObject13(), function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.ui.primary;
});
export var StyledTableBody = styled.tbody(_templateObject14(), function (props) {
  switch (props.displayMode) {
    case 'list':
      {
        return styledTableBodyListStyles;
      }

    case 'table':
      {
        return;
      }

    default:
      {
        return css(_templateObject15(), function (_ref9) {
          var theme = _ref9.theme;
          return theme.breakpoints.m - 1;
        }, styledTableBodyListStyles);
      }
  }
});
export var StyledTableFooter = styled.tfoot(_templateObject16(), function (props) {
  switch (props.displayMode) {
    case 'list':
      {
        return css(_templateObject17());
      }

    case 'table':
      {
        return;
      }

    default:
      {
        return css(_templateObject18(), function (_ref10) {
          var theme = _ref10.theme;
          return theme.breakpoints.m - 1;
        });
      }
  }
});
export var StyledTableRow = styled.tr(_templateObject19(), function (props) {
  switch (props.displayMode) {
    case 'list':
      {
        return css(_templateObject20());
      }

    case 'table':
      {
        return;
      }

    default:
      {
        return css(_templateObject21(), function (_ref11) {
          var theme = _ref11.theme;
          return theme.breakpoints.m - 1;
        });
      }
  }
});
export var SmallScreenHeading = styled.div(_templateObject22(), function (_ref12) {
  var theme = _ref12.theme;
  return theme.responsive.spacing.xs;
}, function (props) {
  switch (props.displayMode) {
    case 'list':
      {
        return;
      }

    case 'table':
      {
        return css(_templateObject23());
      }

    default:
      {
        return css(_templateObject24(), function (_ref13) {
          var theme = _ref13.theme;
          return theme.breakpoints.m;
        });
      }
  }
});
var topRowCellTableStyles = css(_templateObject25(), function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.ui.primary;
});
var topRowCellStyle = css(_templateObject26(), function (props) {
  switch (props.displayMode) {
    case 'list':
      {
        return;
      }

    case 'table':
      {
        return topRowCellTableStyles;
      }

    default:
      {
        return css(_templateObject27(), function (_ref15) {
          var theme = _ref15.theme;
          return theme.breakpoints.m;
        }, topRowCellTableStyles);
      }
  }
});
var cellPadding = css(_templateObject28(), function (_ref16) {
  var theme = _ref16.theme;
  var _theme$responsive$spa = theme.responsive.spacing,
      s = _theme$responsive$spa.s,
      l = _theme$responsive$spa.l;
  return "var(".concat(s, ") var(").concat(s, ") var(").concat(l, ") var(--cell-inline-start-padding)");
});
var styledTableHeadingCellListStyles = css(_templateObject29(), function (_ref17) {
  var theme = _ref17.theme,
      isColumnHeading = _ref17.isColumnHeading;
  var _theme$responsive$spa2 = theme.responsive.spacing,
      m = _theme$responsive$spa2.m,
      l = _theme$responsive$spa2.l;
  return isColumnHeading ? "var(".concat(m, ") 0 var(").concat(l, ")") : "var(".concat(m, ") 0");
});
export var StyledTableHeadingCell = styled.th(_templateObject30(), function (_ref18) {
  var _ref18$width = _ref18.width,
      width = _ref18$width === void 0 ? 'auto' : _ref18$width;
  return width;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.colors.ui.primary;
}, cellPadding, topRowCellStyle, function (props) {
  switch (props.displayMode) {
    case 'list':
      {
        return styledTableHeadingCellListStyles;
      }

    case 'table':
      {
        return;
      }

    default:
      {
        return css(_templateObject31(), function (props) {
          return props.theme.breakpoints.m - 1;
        }, styledTableHeadingCellListStyles);
      }
  }
});
var styledTableCellListStyles = css(_templateObject32(), function (props) {
  return props.theme.responsive.spacing.m;
}, function (props) {
  return props.theme.responsive.spacing.l;
}, function (_ref20) {
  var theme = _ref20.theme,
      hasSmallScreenHeading = _ref20.hasSmallScreenHeading;
  return hasSmallScreenHeading ? "var(".concat(theme.responsive.spacing.l, ")") : "var(".concat(theme.responsive.spacing.m, ")");
}, function (_ref21) {
  var theme = _ref21.theme,
      hasSmallScreenHeading = _ref21.hasSmallScreenHeading;
  return hasSmallScreenHeading ? "var(".concat(theme.responsive.spacing.m, ")") : '0';
}, function (props) {
  return props.theme.colors.ui.primary;
}, function (_ref22) {
  var theme = _ref22.theme;
  return "var(".concat(theme.responsive.spacing.l, ");");
});
export var StyledTableCell = styled.td(_templateObject33(), function (_ref23) {
  var _ref23$width = _ref23.width,
      width = _ref23$width === void 0 ? 'auto' : _ref23$width;
  return width;
}, function (props) {
  return props.theme.colors.ui.primary;
}, cellPadding, topRowCellStyle, function (props) {
  switch (props.displayMode) {
    case 'list':
      {
        return styledTableCellListStyles;
      }

    case 'table':
      {
        return;
      }

    default:
      {
        return css(_templateObject34(), function (props) {
          return props.theme.breakpoints.m - 1;
        }, styledTableCellListStyles);
      }
  }
});